import { render, staticRenderFns } from "./RatingChart.vue?vue&type=template&id=6035951c&"
import script from "./RatingChart.vue?vue&type=script&lang=js&"
export * from "./RatingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports